module.exports = {"id":"199288","name":"Anthony Losilla","rating":"72","photo":"./data/images/photos/4/199288.png","club":{"name":"VfL Bochum","logo":"./data/images/clubs/VfLBochum.png"},"positions":["MDC","MC","DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AnthonyLosilla0.json
// module id = 428
// module chunks = 0